import { PillsInput } from '@mantine/core';

export default PillsInput.extend({
  defaultProps: {
    size: 'md',
  },
});
